import { EmailContentType } from "../enums/common";
export const EMAIL_SENDING_MAX_LIMIT = 10000;
export const EMAIL_BATCH_SIZE = 1000;
export const EMAIL_REGEX_FINDER = /([a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+)/;
export const DYNAMIC_RECIPIENTS_EMAIL_TYPES = [
    EmailContentType.FOLLOW_UP,
    EmailContentType.BLAST,
    EmailContentType.POST_EVENT,
    EmailContentType.REMINDER,
];
export const DELETABLE_EMAIL_TYPES = [EmailContentType.FOLLOW_UP, EmailContentType.BLAST];
export const EMAIL_DELIVERY_LINK_ID_KEY = "zlinkid";
